import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";

// Import Bootstrap CSS file
import "bootstrap/dist/css/bootstrap.css";

// This will import Kendo UI library CSS theme
import "@progress/kendo-theme-default/dist/all.css";

import Toast from "vue-toastification";
import "./scss/toasterNotificatio.scss";

Vue.use(
    Toast,
    {
        icon: false,
        maxToasts: 20,
        timeout: 10000
    }
);

Vue.use(VueRouter);

const routes = [
    {
        path: "*",
        component: () => import("./components/Document.vue"),
    },
    {
        path: "/",
        redirect: {name: "document"}
    },
    {
        path: "/Document/Agreement/:id",
        name: "document",
        component: () => import("./components/Document.vue"),
    },
    {
        path: "/Document/Contract/:id",
        name: "contract",
        component: () => import("./components/Contract.vue"),
    },
];

/* Installazione spinner */
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(VueLoading, {loader: "dots", color: "#188483"});

import {http} from "./interceptor/http-interceptor";

const router = new VueRouter({
    mode: "history",
    root: "/doc",
    routes,
});

http.defaults.baseURL = process.env['VUE_APP_API'];
Vue.config.productionTip = false;

new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");
